import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MathService } from '../services/math/math.service';

@Pipe({ name: 'quantityConversion',pure:false })
export class QuantityConversionPipe implements PipeTransform {
  constructor(private mathService:MathService, private translateService:TranslateService){

  }
  transform(quantity, metric:string, exact:boolean=true,displayZero:boolean=false) {
    let display:string = exact?'':'±';
    if(!quantity){
      if(!displayZero){
        return;
      }
      else{
        quantity = 0;
      }
    }
    if(metric =='gram'){
      if(quantity >= 1000){
        display += this.mathService.convertGrToKgStr(quantity) 
        display += " "+this.translateService.instant('quantityMetric.short.kilogram');
      }
      else{
        display += quantity;
        display += " "+this.translateService.instant('quantityMetric.short.gram');
      }
    }
    else{ 
      display += quantity;
      display += " " + (quantity>1?this.translateService.instant('quantityMetric.short.plural.'+metric):this.translateService.instant('quantityMetric.short.'+metric));
    } 
    return display;
  }
}